module.exports = {
  envDetails: require('./src/envDetails'),
  Popover: require('./src/popover'),
  Tools: require('./src/tools'),
  storage: require('./src/storage'),
  ScrollToTop: require('./src/scroll_to_top'),
  Firebase: require('./src/firebase'),
  Feedback: require('./src/feedback'),
  Analytic: require('./src/analytics')
}
